// React Imports
import React, { Component } from 'react';

// Package Imports
import { observer } from 'mobx-react';
import { useParams } from 'react-router-dom'

// Product Imports
import QmsDetailsPage from 'modules/qms-flow/qms-details-page/QmsDetailsPage';
import QmsDashboardPage from 'modules/qms-flow/qms-dashboard-page/QmsDashboardPage';
import ChooseNeedsAndSetTargets from 'modules/choose-needs/ChooseNeedsAndSetTargets';

import '../../../styles/typo.css';
import QmsMainDashboard from 'modules/qms-flow/qms-dashboard-page/QmsMainDashboard';
import PasaCampaign from 'modules/qms-flow/components/pasa-campaign/PasaCampaign';
import BonusCampaign from 'modules/qms-flow/bonus-campaign/BonusCampaign';
import GapCampaign from 'modules/qms-flow/gap-campaign/GapCampaign';

const QmsDashboard = observer(class QmsDashboard extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <SelectedPage {...this.props} />
    );
  }
});

const SelectedPage = (props) => {
  const { selectedPage } = useParams();

  if (selectedPage === undefined) {
    return <ChooseNeedsAndSetTargets {...props} />
  }
  switch (selectedPage) {
    case 'qms-details':
      return <QmsDetailsPage {...props} />

    case 'qms-dashboard':
      return <QmsDashboardPage {...props} />

    case 'pasa-dashboard':
      return <PasaCampaign />

    case 'upselling-dashboard':
      return <BonusCampaign />

    case 'opportunity-dashboard':
      return <GapCampaign />

    default:
      return <div></div>
  }
}

export default QmsDashboard;
